import { render } from "./Residue.vue?vue&type=template&id=e06ace4e"
import script from "./Residue.vue?vue&type=script&lang=js"
export * from "./Residue.vue?vue&type=script&lang=js"
script.render = render

export default script